// extracted by mini-css-extract-plugin
var _1 = "OptionLabelWithIcon_iconButton__48e4b";
var _2 = "OptionLabelWithIcon_root__24251";
export { _1 as "iconButton", _2 as "root" }
